import React from "react";
import styled from "styled-components";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import { Section, Container } from "@components/global";

const TEAM = [
  {
    name: "Maike Lübeck-Grieshaber",
    image: "00_maike3.jpg",
    role: "Physiotherapeutin, Osteopathin & Heilpraktikerin",
  },
  {
    name: "Kim Hör",
    image: "00_kim2.jpg",
    role: "Physiotherapeut, Osteopath & Heilpraktiker",
  },
  {
    name: "Sabrina Burger",
    image: "00_sabrina2.jpg",
    role: "Physiotherapeutin",
  },
  {
    name: "Melanie Kasper",
    image: "00_melanie2.jpg",
    role: "Physiotherapeutin",
  },
  {
    name: "Lilia Lehmann",
    image: "00_lilia.jpg",
    role: "Physiotherapeutin",
  },
];

const Team = () => (
  <StaticQuery
    query={graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "team" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(maxWidth: 600, maxHeight: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <Section id="mein team" accent="secondary">
        <Container style={{ position: "relative" }}>
          <h1>Mein Team</h1>
          <h3> Erfahren, freundlich und immer für Sie da.</h3>
          <TeamGrid>
            {TEAM.map(({ name, image, role }) => {
              const img = data.allFile.edges.find(
                ({ node }) => node.relativePath === image
              ).node;

              return (
                <div key={name}>
                  <Img
                    style={{ borderRadius: "200px" }}
                    fluid={img.childImageSharp.fluid}
                    alt={name}
                  />
                  <Title>{name}</Title>
                  <Subtitle>{role}</Subtitle>
                </div>
              );
            })}
          </TeamGrid>
        </Container>
      </Section>
    )}
  />
);

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-template-rows: min-content;
  grid-gap: 50px;
  justify-content: space-between;
  margin-top: 72px;

  @media (max-width: ${(props) => props.theme.screen.lg}) {
    justify-content: start;
  }

  @media (max-width: ${(props) => props.theme.screen.md}) {
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  @media (max-width: ${(props) => props.theme.screen.xs}) {
    grid-gap: 24px;
  }
`;

const Art = styled.figure`
  width: 800px;
  margin: -80px 0;
  position: absolute;
  top: 0;
  left: 70%;

  @media (max-width: ${(props) => props.theme.screen.lg}) {
    top: 20%;
  }

  @media (max-width: ${(props) => props.theme.screen.md}) {
    display: none;
  }
`;

const ArtMobile = styled.figure`
  width: 100%;
  margin: 0;
  display: none;
  margin-top: 64px;
  margin-bottom: -60%;

  @media (max-width: ${(props) => props.theme.screen.md}) {
    display: block;
  }
`;

const Title = styled.p`
  margin-top: 16px;
  text-align: center;
  color: ${(props) => props.theme.color.black.regular};
`;

const Subtitle = styled.p`
  ${(props) => props.theme.font_size.small};
  color: ${(props) => props.theme.color.black.light};
  text-align: center;
`;

export default Team;
